import { Meteor } from 'meteor/meteor';
import TrackingAnnotations from '../TrackingAnnotations';

Meteor.publish('trackingAnnotations.all', () => TrackingAnnotations.find({}));

Meteor.publish('trackingAnnotations', function annotations(annotationId) {
  return TrackingAnnotations.find({ annotationId });
});

// Note: annotations.view is also used when editing an existing document.
// Meteor.publish('annotations.view', function annotationsView(annotationId) {
//   check(annotationId, String);
//   return Annotations.find(
//     { _id: annotationId, owner: this.userId },
//     {
//       fields: {
//         owner: 0,
//         createdAt: 0,
//         updatedAt: 0,
//         'geoJSON.properties._id': 0,
//         'geoJSON.properties.owner': 0,
//         'geoJSON.properties.createdAt': 0,
//         'geoJSON.properties.updatedAt': 0
//       }
//     }
//   );
// });

// Meteor.publish('annotations.video', videoId => {
//   check(videoId, String);
//   return Annotations.find(
//     { 'geoJSON.properties.video': videoId },
//     {
//       fields: {
//         owner: 0,
//         createdAt: 0,
//         updatedAt: 0,
//         'geoJSON.properties._id': 0,
//         'geoJSON.properties.owner': 0,
//         'geoJSON.properties.createdAt': 0,
//         'geoJSON.properties.updatedAt': 0
//       }
//     }
//   );
// });
